<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>
      Estoque consolidado - Linha do Tempo
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <div class="d-flex">
      <div class="d-flex flex-column" style="flex: 1">
        <span>Modelo de Kit: {{ estoqueConsolidadoLog?.data[0]?.modeloKit }}</span>
      </div>
      <div class="d-flex flex-column" style="flex: 1">
        <span>Número sequencial: {{ estoqueConsolidadoLog?.data[0]?.numeroSequencial }}</span>
      </div>
    </div>
    <div *ngIf="isLoading" class="d-flex justify-content-center">
      <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <mat-divider></mat-divider>
    <div [hidden]="isLoading || estoqueConsolidadoLog?.data?.length === 0">
      <div>
        <table mat-table [dataSource]="estoqueConsolidadoLog" matSort class="table-sm">
          <!-- Evento -->
          <ng-container matColumnDef="evento">
            <th mat-header-cell *matHeaderCellDef> Evento </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoLog"> {{estoqueConsolidadoLog?.evento}}
            <span *ngIf="estoqueConsolidadoLog.devolucao==1" class="badge badge-warning">Devolução</span> </td>
          </ng-container>

          <!-- Filial  -->
          <ng-container matColumnDef="filialOrigem">
            <th mat-header-cell *matHeaderCellDef> Filial </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoLog"> {{estoqueConsolidadoLog.filialOrigem}} <span *ngIf="estoqueConsolidadoLog?.filialDestino?.length > 0 && estoqueConsolidadoLog?.evento=='Transitória'"><i class="fas fa-arrow-circle-right"></i> {{estoqueConsolidadoLog?.filialDestino}}</span> </td>
          </ng-container>

          <!-- Data -->
          <ng-container matColumnDef="data">
            <th mat-header-cell *matHeaderCellDef> Data </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoLog"> {{estoqueConsolidadoLog?.data}} </td>
          </ng-container>

          <!-- Usuário -->
          <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef> Usuário </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoLog"> {{estoqueConsolidadoLog?.usuario}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsLog"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsLog;"></tr>
        </table>
      </div>
      <app-paginacao [pageIndex]="paging?.index"
        [pageSize]="paging?.size"
        [length]="paging?.length"
        (page)="onPageChange($event)"
        [pageSizeOptions]="[5]"></app-paginacao>
    </div>
    <div *ngIf="!isLoading && estoqueConsolidadoLog?.data?.length === 0" class="d-flex justify-content-center align-items-center" style="height: 100px;">
      Nenhum registro!
    </div>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close color="primary">OK</button>
  </div>
</div>
